<template>
	<!-- <v-dialog
		v-model  = "dialog"
		:width   = "width_dialog"
	> -->
	
	<v-row justify = "center">
		<v-col :cols = "11">		
			<v-card outlined>
				<v-card-title class = "pa-0 body-1 primary white--text text--uppercase">	
					<v-icon
						small 
						color  = "white"
						class  = "ml-1"
						@click = "$router.back()"
					>
						mdi-arrow-left-circle
					</v-icon>

					<v-spacer></v-spacer>
					<v-icon v-text = "'mdi-view-list-outline'" class="mx-1" color="white"></v-icon>
					<span v-text = "$ml.get('trained')"></span>
					<v-spacer></v-spacer>
					
					<!-- Botón CitizenFaceAPI -->
					<v-btn 
						v-if="citizenFaceAPIExists"
						x-small 
						outlined 
						color="white"
						@click="openCitizenModal()" 
						:loading="loadingIntegrations"
						class="mr-2"
					> 
						<v-icon x-small class="mr-1">mdi-account-search</v-icon>
						Citizen
					</v-btn>
					

					<!-- <v-btn 
						x-small 
						outlined 
						icon 
						class  = "error"
			          	@click = "dialog = !dialog"          
			        >
				        <v-icon 
				          	x-small 
				          	color  = "white" 			          	
				          	outlined
				          	v-text = "'mdi-close'"
				        ></v-icon>
			      	</v-btn> -->
				</v-card-title>
				<v-card-text class = "pa-1 py-1">
					<!-- <v-progress-linear indeterminate color="success" v-show="loading"></v-progress-linear> -->
					<v-row dense>		
						<v-col
							v-show 	= "show.add"
							:xl 	 = " show.add ?   3: 12"
							:lg 	 = " show.add ?   3: 12"
							:md 	 = " show.add ?   3: 12"
							:sm 	 = " show.add ?   3: 12"
							:xs 	 = " show.add ?   3: 12"
							cols  	 = "12"
						>
							<v-card outlined>
								<v-card-title class = "pa-1 body-2 primary">
									<v-icon x-small class = "mx-1"> mdi-face-recognition </v-icon>
									<span> {{ head.subtitle }} </span>
								</v-card-title>
								<v-card-text class = "pa-1 mt-1">
									<v-row dense>
										<template v-for = "(item_field, idx_field) of list_fields">
											<v-col :cols  = "12">
												<v-text-field
													dense
													outlined
													:hide-details = "item_field.rules ? false : true"
													v-show 		= "show[item_field.key]"
													v-if 		= "['text', 'number'].includes(item_field.type)"
													v-model 	= "info[item_field.key]"
													:label 		= "item_field.text"		
													:disabled 	= "item_field.disabled" 		
													:required  	= "item_field.is_req"			
													:rules  	= "item_field.rules ? item_field.rules : []"		
												></v-text-field>		
												<v-file-input
													dense
												    outlined
												    multiple
												    v-if 	= "item_field.type == 'file'"
												    :label  = "item_field.text"
												    v-model = "info[item_field.key]"
												    @change = "image_to_b64(info[item_field.key])"
													v-show 	= "show[item_field.key]"
													:required  	= "item_field.is_req"			
													:rules  	= "item_field.rules ? item_field.rules : []"		
													:loading 	= "loadingUpload"
													accept 		= "image/*"
													:error-messages="list_faces.length? messageErrorUpload:[]"
												></v-file-input>
												<v-select
													dense
													outlined
													hide-details
													v-show 		= "show[item_field.key]"
													v-if 		= "['select'].includes(item_field.type)"
													v-model 	= "info[item_field.key]"
													:label 		= "item_field.text"
													:items 		= "item_field.list"
													:item-value = "item_field.item_value"
													:item-text 	= "item_field.item_text"																
													:disabled 	= "item_field.disabled" 
													@change 	= "actions(item_field.action)"							
												></v-select>
											</v-col>
										</template>
										
										<!-- Área de Importación de Carpetas (fuera del v-for) -->
										<v-col :cols="12" v-show="show.files">
											<v-card outlined class="pa-3 mb-3">
												<v-card-title class="pa-1 body-2 primary">
													<v-icon x-small class="mx-1">mdi-folder-plus</v-icon>
													Importar Carpeta
												</v-card-title>
												<v-card-text class="pa-1">
													<v-row dense>
														<v-col cols="12">
															<v-file-input
																dense
																outlined
																multiple
																webkitdirectory
																directory
																:label="'Seleccionar carpeta completa'"
																v-model="folderFiles"
																@change="handleFolderSelection"
																:loading="loadingFolderImport"
																accept="image/*"
																prepend-icon="mdi-folder-multiple"
																:error-messages="folderImportErrors"
																class="mb-2"
															></v-file-input>
														</v-col>
														<v-col cols="12" v-if="folderFiles && folderFiles.length > 0">
															<v-alert type="info" outlined dense>
																<strong>Archivos seleccionados:</strong> {{ folderFiles.length }} imágenes
															</v-alert>
															<v-btn
																x-small
																color="success"
																@click="compressAndUploadFolder"
																:loading="loadingCompression"
																:disabled="!folderFiles || folderFiles.length === 0"
																class="mt-2"
															>
																<v-icon left x-small>mdi-zip-box</v-icon>
																Comprimir y Enviar
															</v-btn>
														</v-col>
													</v-row>
												</v-card-text>
											</v-card>
										</v-col>
										<v-divider></v-divider>
										<v-col :cols="12" v-show="list_faces && list_faces.length > 0">
											<v-item-group >
												<v-container fluid class="pt-0 pb-5 pt-1 overflow-y-auto">
													<v-row dense>
													<v-col 
														v-for  	= "(item_face, idx_face) of render_list_faces" 
														:key 	= "'list_faces_' + idx_face" 
														cols 	= "auto"  
														style 	= "justify: center;"
													>
														<!-- @click 	="sel(n)"  -->
														<v-item v-slot:default = "{ active, toggle }">
															<v-card 
																dark  
																outlined
																:color 	= "active ? 'primary' : item_face.isValid ? 'success': item_face.isInvalid ? 'error': '' "  
																style 	= "width:80px"  
																@click 	= "toggle" 
																class 	= "pl-1 ma-0" 
															>	
																<v-card-title class = "pa-0 ma-0 secodary justify-center" style = "font-size: 70%; line-height: 110%">
																	<v-spacer></v-spacer>
																	<v-tooltip top>
																		<template v-slot:activator = "{ on }">
																			<v-btn
																				fab
																				x-small
																				color   = "error"
																				@click  = "actions('confirm_delete_face', item_face)"
																				width   = "15"
																				height  = "15" 
																				v-on 	= "on"

																			>
																				<v-icon x-small color="white"> mdi-delete </v-icon>
																			</v-btn>
																		</template>
																		<span> {{ $ml.get('delete') }} </span>		
																	</v-tooltip>
																</v-card-title>																		
																	<v-scroll-y-transition>							                  
													                 	<v-img  												                 		
													                 		:src   = "$Helper.check_img(item_face.url_face, $URL)" 
													                 		@error = "item_face.url_face = '/img/no_img_found.png'"
													                 		width  = "70" 
													                 		height = "64"
													                 		contain
													                 	></v-img>
														            </v-scroll-y-transition>			
														            <v-card-actions style = "font-size: 70%; line-height: 110%">
														            	<span> {{ item_face.msg }}</span>
														            </v-card-actions>										             	
																</v-card>
															</v-item>
														</v-col>
													</v-row>	
												</v-container>
												
											</v-item-group>
										</v-col>
									</v-row>
								</v-card-text>
								<v-divider></v-divider>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn
										x-small
										@click 		= "actions(head.action)"
										v-show 		= "show.add_trained"
										:disabled 	= "check_is_disabled_save"
										color  		= "primary"
									>	
										{{ $ml.get(head.action) }}
									</v-btn>
								</v-card-actions>
							</v-card>
							
						</v-col>				
						<v-col
							:xl 	 = " show.add ?   9: 12"
							:lg 	 = " show.add ?   9: 12"
							:md 	 = " show.add ?   9: 12"
							:sm 	 = " show.add ?   9: 12"
							:xs 	 = " show.add ?   9: 12"
							:cols 	 = " show.add ?   12 : 12"
						>
							<v-card outlined
								
							>
								
							
							<v-toolbar						    		
					    		dense
					    		height = "25"
					    		class  = "secondary white--text"
					    	>
					    		<v-icon
									small
									color = "white"
									class = "mr-1"
								>
									mdi-view-list
								</v-icon>
						    	<v-toolbar-title 
						    		class = "body-2"
						    	>
						    		{{ $ml.get('registered_faces') }}
						    	</v-toolbar-title>
						    	<v-spacer></v-spacer>
						    	<v-btn
						    		fab
						    		x-small
						    		height = "23"
						    		width  = "23"
						    		:color = "show.add ? 'error' : 'primary'"
						    		@click = "actions('add_trained')"
						    		v-show = "show.add_trained"
						    	>
						    		<v-icon
						    			x-small
						    		>
						    			{{ show.add ? "mdi-close" : "mdi-plus" }}
						    		</v-icon>
						    	</v-btn>
						    </v-toolbar>							
							<v-divider></v-divider>
							 <v-data-table
							 	:key="tablekey"
								dense
							    fixed-header
							    show-expand
							    :headers 				= "headers"
							 	:items 					= "render_list"
							    class 					= "elevation-5"			    
							    :hide-default-footer 	= "height < 56 ?  true : false"
							   	:options.sync 			= "options"
							   	:server-items-length 	= "total"
							   	:expanded.sync 			= "expanded"
							   	:footer-props 			= "{
							   		showFirstLastPage 	: true,
							   		itemsPerPageOptions : [30],
							   		showCurrentPage 	: true
							   	}"				   	
							    :height 				= "height + 'px'"
							    item-key 				= "id"
							    :loading 				= "loading"
							>
								<template v-slot:top>
									<!-- <v-toolbar mandatory height="25" class="mt-5"> -->
									<v-text-field outlined dense :label="$ml.get('search')" class="my-2" prepend-inner-icon="mdi-magnify" v-model="search" @keyup.enter="get_list_trained()"></v-text-field>
									<!-- </v-toolbar> -->
								</template>
								<template v-slot:item.url_face="{ item }">
									<v-img
										contain
										:src 	= "item.url_face"
										:height = "45"
										:width  = "45"

									></v-img>
								</template>
								
								<template  v-slot:item.actions="{ item }">
									<v-btn
										x-small	
								        color 	= "primary"
								        @click 	= "actions('select_user', item)" 
								        class 	= "mr-1"							        
									>
									<v-icon
								        small
								    >
								        mdi-pencil
								    </v-icon>
									</v-btn>
									<v-btn
										x-small
								        color 	= "error"
								        @click  = "actions('confirm_delete', item)"

									>
									    <v-icon
									        small
									    >
									        mdi-delete
									    </v-icon>
									</v-btn>
								</template>
								<template v-slot:expanded-item = "{ headers , item }">
									<td 
										:colspan = "headers.length"
									>
										<template
											v-for = "(item_trained, idx_trained) of options_traineds"
										>
											
											<v-btn
												x-small
												:color 		= "item_trained.color"
												@click 		= "actions(item_trained.action, item)"
												:class 		= "item_trained.class"
												:disabled 	= "item && item.selecteds && item.selecteds.length > 0 ? false : true " 
											>
												{{ item_trained.text }}
											</v-btn>
										</template>
	     								<v-item-group 
	     									multiple
	     									v-model = "item.selecteds"
	     								>
											<v-container fluid 
												class 	= "pt-0 pb-5 pt-1 overflow-y-auto"  
												id 		= "scroll-target"  
												:style  = "{ overflowX:'hidden', height: head.height_extended +'px' }"
												 
											> <!-- 18vh -->
											<!-- height: 200px -->
												<!-- <v-btn
													float
													absolute
													fab
													height = "23"
													width  = "23"
													color  = "primary"
													@click = "actions('new_train')"
													v-show = "show.add_trained"
												>
													<v-icon
														x-small
													>
														mdi-face-recognition
													</v-icon>
												</v-btn> -->
												<v-row 
													dense
													v-scroll:#scroll-target = "onScroll"  
													:style 					= "{height: head.height_card +'px'}"
													v-if 					= "item && item.face_trained && item.face_trained.length > 0"
												>
												
												<!-- style="height:20vh;"  / .slice().reverse()-->
														<!-- @click 	="sel(n)"  -->
													<v-col 
														v-for  	= "n of item.face_trained" 
														:key 	= "n.id" 
														cols 	= "auto"  
														sm 		= "auto" 
														lg 		= "auto" 
														md 		= "auto" 
														xl 		= "auto" 
														style 	= "justify: center;"
													>
														<v-item 
															v-slot:default = "{ active, toggle }"
														>
															<v-card 
																dark  
																outlined
																:color 	= "active ? 'primary' : n.status ? 'success' : 'red lighten-2'"  
																style 	= "width:80px"  
																@click 	= "toggle" 
																class 	= "pl-1 ma-0" 
															>	
															<!-- active ? 'primary' : ''  -->
																<v-card-title 
																	class = "pa-0 ma-0 secodary justify-center" 
																	style = "font-size: 70%; line-height: 110%"
																>
																	<span>														
																		{{n.name}}
																	</span>
																	<v-spacer></v-spacer>
																	<v-tooltip
																		top
																	>
																		<template
																			v-slot:activator = "{ on }"
																		>
																			
																			<v-btn
																				fab

																				x-small
																				color   = "error"
																				
																				width   = "15"
																				height  = "15" 
																				v-on 	= "on"
																				@click 	= "actions('confirm_delete_face', n, item)"
																			>
																				<v-icon
																					x-small
																					color = "white"
																				>
																					mdi-delete
																				</v-icon>
																			</v-btn>
																		</template>
																		<span>
																			{{ $ml.get('delete') }}
																		</span>		
																	</v-tooltip>
																</v-card-title>		
																<!-- $protocol + 
													                 			     $localhost + ':' + 
													                 			     $port_face + '/media/' + 
													                 			     n.trained_thumbnail -->				
													                 			     <!-- n.trained_thumbnail						 -->
																  <v-scroll-y-transition>							                  
													                 	<v-img  
													                 		contain
													                 		
													                 		:src   = "$Helper.check_img(n && n.face_cropping ? n.face_cropping.url : '/img/no_img_found.png', $URL)" 
													                 		@error = "n.face_cropping.url = '/img/no_img_found.png'"
													                 		width  = "70" 
													                 		height = "64"
													                 	>
													                 		<!-- @click = "actions('select_trained', n)" -->
													                 		<!-- <v-icon
													                 			small
													                 			color = "primary"
													                 			class = "mt-12"
													                 		>
													                 			mdi-pencil
													                 		</v-icon> -->
													                 	</v-img>

													                 	<!-- w: 64 -->
													                  <!-- 48 -->
													                  <!-- 64 -->
													                </v-scroll-y-transition>
													                <v-divider></v-divider>	
													               <!--  <v-card-actions
													                	class = "justify-center"
													                >
													                	<v-btn
													                		x-small
													                		color = "primary"

													                	>
													                		{{ $ml.get("to_train") }}
													                	</v-btn>
													                </v-card-actions> -->
															</v-card>
														</v-item>
													</v-col>
												</v-row>	
											</v-container>
											
										</v-item-group>
	     							</td>								
								</template>
							</v-data-table>		
							
							</v-card>
						</v-col>
					</v-row>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<!-- <v-btn 
						x-small
						color   = "error"
						v-text  = "$ml.get('close')"
						@click  = "dialog = !dialog"
					></v-btn> -->
				</v-card-actions>
			</v-card>

		</v-col>
		
		<!-- Modal CitizenFaceAPI -->
		<v-dialog v-model="showCitizenModal" max-width="600px">
			<v-card>
				<v-card-title class="text-h6">
					<v-icon class="mr-2">mdi-account-search</v-icon>
					CitizenFace API
				</v-card-title>
				
				<v-card-text>
					<div class="pa-4">
						<p class="text-h6 mb-4 text-center">Query Citizen by ID</p>
						
						<v-text-field
							v-model="citizenId"
							label="Citizen ID"
							placeholder="Enter citizen ID"
							outlined
							dense
							class="mb-4"
							:rules="[v => !!v || 'Required']"
							required
						></v-text-field>
						
						<div class="text-center">
							<v-btn
								color="primary"
								@click="consultarCiudadano()"
								:loading="loadingCitizenQuery"
								:disabled="!citizenId || !citizenIntegration"
								class="mb-4"
							>
								<v-icon left>mdi-magnify</v-icon>
								Consult
							</v-btn>
						</div>
						
						<v-expand-transition>
							<div v-if="citizenResult">
								<v-divider class="my-4"></v-divider>
								<div class="text-center">
									<v-alert
										:type="citizenResult.success ? 'success' : 'error'"
										outlined
										class="mb-3"
									>
										{{ citizenResult.message }}
									</v-alert>
									
									<div v-if="citizenResult.success && citizenResult.image" class="text-left">
										<v-card outlined class="pa-3">
											<div class="text-center">
												<h6 class="mb-3">Citizen Image</h6>
												<v-img
													:src="'data:image/jpeg;base64,' + citizenResult.image"
													alt="Imagen del ciudadano"
													max-width="200"
													max-height="250"
													contain
													class="mx-auto"
												></v-img>
												
												<div class="mt-4">
													<v-btn
														color="success"
														outlined
														@click="addCitizenToTrained()"
														:loading="loadingAddCitizen"
														:disabled="isCitizenAlreadyImported"
														class="mr-2"
													>
														<v-icon left>mdi-import</v-icon>
														Import to Trained
													</v-btn>
												</div>
											</div>
										</v-card>
									</div>
								</div>
							</div>
						</v-expand-transition>
						
						<v-alert type="info" outlined class="mt-4">
							<strong>Endpoint:</strong> {{ citizenIntegration ? citizenIntegration.ip_address : 'Not configured' }}
						</v-alert>
					</div>
				</v-card-text>
				
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn 
						color="error" 
						outlined
						@click="showCitizenModal = false"
					>
						Close
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<!-- Modal Importar Carpeta -->
		<v-dialog v-model="showFolderImportModal" max-width="700px">
			<v-card>
				<v-card-title class="text-h6">
					<v-icon class="mr-2">mdi-folder-plus</v-icon>
					Importar Carpeta de Imágenes
				</v-card-title>
				
				<v-card-text>
					<div class="pa-4">
						<p class="text-body-1 mb-4 text-center">Selecciona una carpeta para importar y comprimir todas las imágenes</p>
						
						<v-file-input
							dense
							outlined
							multiple
							webkitdirectory
							directory
							:label="'Seleccionar carpeta completa'"
							v-model="folderFiles"
							@change="handleFolderSelection"
							:loading="loadingFolderImport"
							accept="image/*"
							prepend-icon="mdi-folder-multiple"
							:error-messages="folderImportErrors"
							class="mb-4"
						></v-file-input>
						
						<div v-if="folderFiles && folderFiles.length > 0">
							<v-alert type="info" outlined dense class="mb-3">
								<strong>Archivos seleccionados:</strong> {{ folderFiles.length }} imágenes
							</v-alert>
							
							<v-btn
								color="success"
								@click="compressAndUploadFolder"
								:loading="loadingCompression"
								:disabled="!folderFiles || folderFiles.length === 0 || processingStatus === 'processing'"
								class="mt-2"
							>
								<v-icon left>mdi-zip-box</v-icon>
								{{ processingStatus === 'processing' ? 'Procesando...' : 'Comprimir y Enviar' }}
							</v-btn>
						</div>
						
						<!-- Progreso en tiempo real -->
						<v-expand-transition>
							<div v-if="processingStatus === 'processing'">
								<v-divider class="my-4"></v-divider>
								
								<!-- Barra de progreso -->
								<div class="mb-4">
									<h6 class="mb-2">Progreso del Procesamiento</h6>
									<v-progress-linear
										:value="processingProgress.percentage"
										height="25"
										color="primary"
										class="mb-2"
									>
										<template v-slot:default>
											<strong>{{ processingProgress.percentage }}%</strong>
										</template>
									</v-progress-linear>
									<p class="text-caption">
										{{ processingProgress.current }} / {{ processingProgress.total }} archivos procesados
									</p>
								</div>
								
								<!-- Detalles del procesamiento -->
								<v-card outlined class="pa-3 mb-3">
									<h6 class="mb-2">Estado Actual</h6>
									<v-row dense>
										<v-col cols="12" md="4">
											<strong>Archivo:</strong> {{ processingDetails.currentFile || 'N/A' }}
										</v-col>
										<v-col cols="12" md="4">
											<strong>Operación:</strong> {{ processingDetails.currentOperation || 'N/A' }}
										</v-col>
										<v-col cols="12" md="4">
											<strong>Tiempo estimado:</strong> {{ processingDetails.estimatedTime || 'N/A' }}
										</v-col>
									</v-row>
								</v-card>
								
								<!-- Logs en tiempo real -->
								<v-card outlined class="pa-3">
									<div class="d-flex justify-space-between align-center mb-2">
										<h6>Logs del Procesamiento</h6>
										<v-btn
											x-small
											text
											color="primary"
											@click="clearProcessingLogs"
										>
											Limpiar
										</v-btn>
									</div>
									<div 
										class="processing-logs-container"
										style="max-height: 200px; overflow-y: auto; background: #f5f5f5; padding: 10px; border-radius: 4px;"
									>
										<div 
											v-for="(log, index) in processingLogs" 
											:key="index"
											class="log-entry mb-1"
											:class="getLogEntryClass(log.type)"
										>
											<small class="text-caption">{{ log.timestamp }}</small>
											<span class="ml-2">{{ log.message }}</span>
										</div>
										<div v-if="processingLogs.length === 0" class="text-caption text-center text-muted">
											Esperando logs del backend...
										</div>
									</div>
								</v-card>
							</div>
						</v-expand-transition>
						
						<!-- Estado completado -->
						<v-expand-transition>
							<div v-if="processingStatus === 'completed'">
								<v-divider class="my-4"></v-divider>
								<v-alert type="success" outlined>
									<strong>¡Procesamiento Completado!</strong><br>
									Se procesaron {{ processingProgress.total }} archivos exitosamente.
								</v-alert>
							</div>
						</v-expand-transition>
						
						<!-- Estado de error -->
						<v-expand-transition>
							<div v-if="processingStatus === 'error'">
								<v-divider class="my-4"></v-divider>
								<v-alert type="error" outlined>
									<strong>Error en el Procesamiento</strong><br>
									Revisa los logs para más detalles.
								</v-alert>
							</div>
						</v-expand-transition>
					</div>
				</v-card-text>
				
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn 
						color="error" 
						outlined
						@click="showFolderImportModal = false"
					>
						Cancelar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-col>
</v-row>
</template>
<script>
	export default{
		name  : 'Trained',
		props : [
			'open_modal'
		],
		data  : (vm) => ({
			head 		 : { 
				height_card : 200,
				subtitle 	: vm.$ml.get("new"),
				action 		: "save",
				height_extended : 150,
			},
			list  	 	 : [],
			total 	 	 : 1,
			dialog 		 : false,
			width_dialog : 600, 
			height  	 : 520,
			offsetTop    : 0,
			show 		 : {
				add 			: false,
				add_trained   	: true,
				edit_trained    : true,
				delete_trained  : true,
				type 			: true,
				name 			: false,
				userName 		: true,
				date_at 		: false,
				number_trained  : false,
				files 			: true,
				name 			: false,
			},
			disableds 			: {
				add_trained 	: true,
			},
			info 		: {
				type : "user",
			},
			item_info 	: null,
			search : "",
			headers 	: [
				{ text : vm.$ml.get("username"), value : "userName" },
				{ text : vm.$ml.get("uuid"), value : "userId" },				
				{ text : vm.$ml.get("face"), value : "url_face" },
				{ text : vm.$ml.get("createdAt"), value : "date_at" },
				{ text : vm.$ml.get("actions"), value : "actions" },

			],
			expanded 	: [],
			options 	: { page : 1, itemsPerPage : 30},
			list_fields : [
				{
					key 		: "type",
					type 		: "select",
					text  		: vm.$ml.get("type"),
					item_value  : "key",
					item_text   : "text",
					action 		: "show_type", 
					disabled 	: true,
					list 		: [
						{
							key  : "user",
							text : vm.$ml.get("user"),
						},
						{
							key  : "trained",
							text : vm.$ml.get("trained"),
						},
					]
				},
				{
					key   	: "name",
					type 	: "text",
					text 	: vm.$ml.get("username"), 
					is_req  : true,
					rules   : [(value) => !!value || vm.$ml.get('required')], 
				},
				{
					key   	: "userName",
					type 	: "text",
					text 	: vm.$ml.get("username"), 
					// is_req  : true,
					// rules 	  : [(value) =>  !!value || 'Required.'],
				},
				{
					key   		: "date_at",
					type 		: "text",
					text 		: vm.$ml.get("createdAt"), 
					disabled 	: true, 
				},
				{
					key   		: "number_trained",
					type 		: "number",
					text 		: vm.$ml.get("number_trained"),
					disabled 	: true, 
				},
				{
					key 	: "files",
					type 	: "file",
					text 	: vm.$ml.get("seleccion_files_to_train"),
					is_req  : true,
					rules   : [(value) => !!value || vm.$ml.get('required')], 
				},

				{
					key 	: "email",
					type 	: "text",
					text 	: vm.$ml.get("email")
				}
			],
			list_faces 			: [],
			loading 			: false,
			ID_notification 	: "trained",
			bus 				: {},
			loadingUpload 		: false,
			messageErrorUpload : [],
			options_traineds 	: [
				/*
				{
					key 	: "to_train",
					action 	: "to_train",
					color 	: "primary",
					text 	: vm.$ml.get("to_train"),
					class 	: "mx-1 my-1"
				},
				{
					key 	: "to_delete",
					action 	: "to_delete_traineds",
					color 	: "error",	
					text 	: vm.$ml.get("delete"),

				}*/
			],
			tablekey:0,
			filterTozero:false,
			
			// CitizenFaceAPI properties
			citizenFaceAPIExists: false,
			showCitizenModal: false,
			loadingIntegrations: false,
			citizenId: '',
			citizenResult: null,
			loadingCitizenQuery: false,
			citizenIntegration: null,
			loadingAddCitizen: false,
			
			// Folder import properties
			folderFiles: [],
			loadingFolderImport: false,
			loadingCompression: false,
			folderImportErrors: [],
			showFolderImportModal: false,
			
			// Real-time processing properties
			processingStatus: 'idle', // idle, processing, completed, error
			processingProgress: {
				current: 0,
				total: 0,
				percentage: 0
			},
			processingLogs: [],
			processingDetails: {
				currentFile: '',
				currentOperation: '',
				estimatedTime: ''
			},
			websocketConnection: null,
			eventBusListener: null,
			folderImportInfo: {
				name: '',
				email: ''
			},
			selectedFolder: null,
			selectedFiles: [],
			loadingFolderSelection: false,
			compressionOptions: {
				quality: 80, // 0-100
				format: 'jpeg' // 'jpeg', 'png', 'webp'
			},
			compressionQualityOptions: [
				{ value: 10, text: '10%' },
				{ value: 20, text: '20%' },
				{ value: 30, text: '30%' },
				{ value: 40, text: '40%' },
				{ value: 50, text: '50%' },
				{ value: 60, text: '60%' },
				{ value: 70, text: '70%' },
				{ value: 80, text: '80%' },
				{ value: 90, text: '90%' },
				{ value: 100, text: '100%' }
			],
			compressionFormatOptions: [
				{ value: 'jpeg', text: 'JPEG' },
				{ value: 'png', text: 'PNG' },
				{ value: 'webp', text: 'WebP' }
			],
			compressionProgress: {
				show: false,
				percentage: 0,
				currentFile: '',
				totalFiles: 0
			}

		}), // data
		created(){
			// this.get_list_trained();
			
			let modul = this.$store.getters["auth/permission"](this.$route.name || "face", "", "face");

			if (modul) {
				if (!modul.can_add) { this.show.add_trained  = false }
				if (!modul.can_edit) {this.show.edit_trained = false }
				if (!modul.can_delete) {this.show.delete_trained = false }
			}
			
			// Verificar si existe integración CitizenFaceAPI
			this.checkCitizenFaceAPIIntegration();

		}, // created


		watch : {
			open_modal: function(val) {
				if (val) {
					this.dialog = true;
				}
			}, // open modal

			dialog: function(val){
				if (!val) {
					this.$emit('close', false)
				}
			}, // dialog

			options:{
				handler(val){
					this.get_list_trained()
				},deep:true
			},
			search(newVal) {
				console.log(newVal)
				if (newVal === "") {
					//this.isServerSearch = true;
					this.get_list_trained();
				}

				console.log(this.render_list.length)
				if(this.filterTozero){
					this.filterTozero=false
					this.get_list_trained();
				}
				if(this.render_list.length==0){
					this.get_list_trained();
					this.filterTozero=true
					//this.tablekey=1					
				}

				
			},

		}, // watch

		computed : {
			render_list(){
				if(this.list && this.list.length){
					if(this.search){
						const searchTemp = this.search.toLowerCase();
						
						const temp = this.list.filter(x=> (x?.userName.toLowerCase().includes(searchTemp)|| x.userId.includes(searchTemp) || x.email?.includes(searchTemp) ))						
						return temp;// this.renderPaginate()
					}else{
						return this.list; //this.renderPaginate()
					}
				}else{
					return [];
				}
			}, // render list
			
			render_list_faces : function(){
				return this.list_faces;
			}, // render list faces

			check_is_disabled_save : function(){
				if (this.head) {
					if (this.head.action == "save") {
						const { name, files } = this.info;
						
						// Si no hay files pero hay list_faces (caso de ciudadano importado), permitir guardar
						if (!files && this.list_faces && this.list_faces.length > 0) {
							// Verificar que al menos una imagen sea válida
							const hasValidFaces = this.list_faces.some(face => face.isValid);
							if (!name || !hasValidFaces || this.messageErrorUpload.length) {
								return true;
							}
							return false; // Habilitar botón si hay nombre y faces válidos
						}
						
						// Lógica original para archivos subidos
						if(files && files.length==0){
							this.list_faces=[];
						}
						if (!name || !files || (files && files.length === 0) || this.messageErrorUpload.length) {
							return true;
						}						
					}
				}
				return false;
			}, //
			
			// Check if current citizen is already imported
			isCitizenAlreadyImported() {
				if (!this.citizenId || !this.list) {
					return false;
				}
				return this.list.some(face => face.citizenId === this.citizenId);
			}, 

			canProcessFolder() {
				return this.selectedFolder && this.selectedFiles.length > 0;
			}
		}, // computed

		methods : {

			actions(act, item, opt){
				//console.log("actions ", act, item, opt)
				if (act == "add_trained") {
					// console.log("INFO ", this.info)
					
					//console.log(this.show.add, this.head.action)
					this.show.add = !this.show.add;
					if (this.head.action == 'update' && !this.show.add) {
						this.head.action 	= "save";
						this.head.subtitle 	= this.$ml.get("new");
						if (this.info && this.info.files) {
							delete this.info.files;
						}
						this.info 			= {
							type : "user",
						};
						this.list_faces 	= [];
					}else{
						this.actions("show_type");
						
					}


				}else
				if (act == "save"){
					this.save();
				}else
				if (act == "update") {
					this.update();
					this.show.add = false
					this.head.action 	= "save";
					this.head.subtitle 	= this.$ml.get("new");
				}else
				if (act == "select_user") {
					this.head.action = 'update';
					this.info 		 = item;
					this.info.type 	 = "user";
					this.list_faces  = [];
					// this.info.files  = [];
					this.show.add 	 = true;
					this.actions("show_type");

					this.head.subtitle = this.$ml.get("edit");
					/*if (item && item.face_trained && item.face_trained.length > 0) {
						this.list_faces = item.face_trained;
					}*/
				}else 
				if (act == "confirm_delete") {
					this.item_info = { ...item };
					this.$EventBus.$emit("notifications_modal",{
						type 	: "confirm_delete",
						ID 		: this.ID_notification,
						action  : {
							action : "del"
						}
					})
				}else 
				if (act == "select_face") {

				}else 
				if (act == "confirm_delete_face") {
					if (opt) {
						this.info 		= opt ; 
					}
					this.item_info 	= { ...item };
					this.$EventBus.$emit("notifications_modal",{
						type 	: "confirm_delete",
						ID 		: this.ID_notification,
						action  : {
							action : "del_face"
						}
					})
				}else
				if (act == "show_type") {				
					if (this.info) {
							console.log("INFO ", this.info)
							this.show.name 			 = false;
							this.show.userName 		 = false;
							this.show.date_at 		 = false;
							this.show.number_trained = false;
							this.show.files 		 = false;
							if (this.info.type  == "user") {
								// this.show.name = true;
								this.show.name 		 	= true;
								this.show.files 		= true;
								this.show.email			= true;
								if (this.info.id) {						
									this.show.name 				= false;
									this.show.userName			= true;											
									this.show.date_at 			= true;
									this.show.number_trained 	= true;
								}else{
									this.show.files 		= true;

								}
							}else
							if (this.info.type == "trained") {
								this.show.name 		 			= true;
								this.show.files 		 		= true;

							}
						}
				}else
				if (act == "to_train") {
					this.to_train_face(item);
				}else
				if (act == "to_delete_traineds") {

				}
			}, // actions

			renderPaginate(items){
				const start = (this.options.page-1)*this.options.itemsPerPage;
				// console.log("PAGES ", items.slice(start, start + this.options.itemsPerPage))
				return items.slice(start, start + this.options.itemsPerPage); 
			},
			async image_to_b64(files){
				try{
					if (files && files.length > 0) {
						this.list_faces = [];	
						this.loadingUpload=true;
						let tempImgs = []				
						// add images b64
						for(const idx_fil in files){						
							if (files[idx_fil]) {
								const b64 = await this.$Helper.file_to_b64(files[idx_fil]) 
								if (b64) {
								// console.log("B64 : ", b64)
									tempImgs.push({imgBase64 : b64})
								}// if b64
									if(idx_fil == files.length-1){
									}
							}
						}// for 1
						let tempText=[];
						let count=0;
						let count1=0;
						// validator
						for(const idxValid in tempImgs){												
							const res = await this.validateFaceUpload([tempImgs[idxValid]])											
							if(res && res.data && res.data.length){
								// tempImgs.forEach((img, idx)=>{
									// tempImgs[idxValid]
									const item = res.data[0];
									if(item && item.bbox){
										this.list_faces.push({
											url_face    : tempImgs[idxValid].imgBase64,
											key 		: idxValid + 1,//idx_fil
											isValid 	: true,
										})															
										count++;
									}else{
										count1++;
										this.list_faces.push({
											url_face    : tempImgs[idxValid].imgBase64,
											key 		: idxValid + 1, //idx_fil
											isInvalid 	: true,
											msg 		: item?.msg,
										})						
										if(item?.msg){
											if(item.msg == "Cant find face in input"){
												tempText.push(this.$ml.get("Cant find face in input"))
											}else{
												tempText.push(item.msg) 
											}
										}
									}
								// })														
							}									
							
						} // for
						const tempError=`${this.$ml.get("validated_images")} : ${count} ; 
							${this.$ml.get("invalid_images")} : ${count1} ; 
							${this.$ml.get("error")}: ${tempText?tempText.join(","):''}`
						this.$EventBus.$emit("notifications_modal",{ type: count ? "success" : "warning", direction: " ", message: tempError })
						if(count1){
							this.messageErrorUpload=[tempError]
						}else{
							this.messageErrorUpload=[];
						}
						this.loadingUpload=false	
					}
				}catch(error){
					console.warn("Error convert to b64 ", error)
				}
			}, // image to b54
			validateFaceUpload(imgs){
				const url= this.$URL+"/api/v1/face/validation";
				return this.$axios.post(url,imgs).then(res=> Promise.resolve(res)).catch(error=> Promise.reject(error));
			},

			onScroll (e) {
	    		this.offsetTop = e.target.scrollTop
	  		},

	  		format_info(item){
	  			if (item) {
	  				if (item && item.face_trained && item.face_trained.length > 0 &&  item.face_trained[0].face_cropping &&  item.face_trained[0].face_cropping.url) {
	  					item.url_face 		= this.$URL + item.face_trained[0].face_cropping .url;	  					
	  					item.number_trained = item.face_trained.length;
	  					
	  				}else{
	  					item.url_face 		= this.$EXT + "/img/no_img_found.png";	  					
	  					item.number_trained = 0;
	  				}
	  				if (item.createdAt) {	  					
	  					item.date_at 	= this.$Format.format_date(item.createdAt, "createdAt");
	  				}
	  				item.selecteds = [];
	  			}
	  			return item;
	  		}, // format info

			async get_list_trained(){				
		        try{
		         	this.loading=true; 	
					const { page } = this.options;					
					const api = this.$URL + "/api/v1/face/trained/"; // ?page= / this.$URL_face + '/api/face/list?page=' + page;					
					const listed =  await  this.$axios.get(api,{ params: {page, search: this.search? { userName : this.search} : undefined}}).then( res => {
						if (res && res.data) {
							let items 	= res.data.rows;
							this.total=res.data.count;
							if (items && items.length > 0) {
								items.forEach((it)=>{
									it = this.format_info(it);
								})
								// console.log("check ", items)
								this.list=items;
								//this.tablekey++
							}
							
						}			            
					}).catch( er =>{
						console.log(er, 'error get list trained')
					});
		        }catch(error){		        	
					console.log('error get list trained', error )
		        }finally{
		        	this.loading=false; 	
					//
		        }		       	
			}, // get_list_trained

			save(){
				if (!this.$store.getters["auth/permission"](this.$route.name || "face", "can_add", "face")) {
					this.$EventBus.$emit("notifications_modal", {
						type 	: "warning",
						message : this.$ml.get("no_have_permission_create") + " : " + (this.$route.name || "face") 
					});
					return false
				}
				
				// Verificar que haya imágenes para procesar
				if (!this.list_faces || this.list_faces.length === 0) {
					this.$EventBus.$emit("notifications_modal", {
						type: "warning",
						message: "No hay imágenes para procesar"
					});
					return false;
				}
				
				let info_up = { ...this.info };
				let api = this.$URL + "/api/v1/face/add";
				
				if (this.info && this.info.type == "user"){
					api = this.$URL + "/api/v1/face/user";
				}
				
				this.loading = true;
				let formData = new FormData();
				
				// Agregar campos del formulario
				if (info_up) {
					for(let it in info_up){
						console.log("IT ", it, info_up[it])
						if (it && info_up[it] && it != "files") {
							formData.append(it, info_up[it]);
						}
					}
				}
				
				// Procesar imágenes de list_faces (caso de ciudadano importado)
				if (this.list_faces && this.list_faces.length > 0) {
					this.list_faces.forEach((face, idx) => {
						if (face && face.imgBase64) {
							// Convertir base64 a Blob para FormData
							const base64Data = face.imgBase64.split(',')[1]; // Remover data:image/... prefix
							const byteCharacters = atob(base64Data);
							const byteNumbers = new Array(byteCharacters.length);
							for (let i = 0; i < byteCharacters.length; i++) {
								byteNumbers[i] = byteCharacters.charCodeAt(i);
							}
							const byteArray = new Uint8Array(byteNumbers);
							const blob = new Blob([byteArray], { type: 'image/jpeg' });
							
							// Crear archivo con nombre descriptivo
							const fileName = `citizen_${face.citizenId || 'face'}_${idx}.jpg`;
							const file = new File([blob], fileName, { type: 'image/jpeg' });
							
							formData.append(`files${idx}`, file);
						}
					});
				}
				
				// Procesar archivos subidos manualmente (caso original)
				if (info_up.files && info_up.files.length > 0) {
					info_up.files.forEach((it, idx) => {
						formData.append(`files${idx}`, it);
					});
				}

				console.log("FormData preparado:", formData);
				
				this.$axios.post(api, formData).then(res => {
					this.loading = false;
					if (res && res.data) {
						let temp = this.format_info({...res.data});
						if (temp) {
							this.list.unshift({...temp});
							this.$Format.add_to_lists("list_traineds", {...temp});
						}
						this.list_faces = [];
						this.show.add = false;
						this.info = { type: "user" };
					}
					this.$EventBus.$emit("notifications_modal", {
						type: "saved",
					});
				}).catch(er => {
					this.loading = false;
					console.log("Error create trained ", er);
					this.$EventBus.$emit("notifications_modal", {
						type: "error",
						message: er.response?.data?.message || er.message || "Error al guardar"
					});
				});
			}, // save

			update(){
				if (!this.$store.getters["auth/permission"](this.$route.name || "face", "can_edit", "face")) {
					this.$EventBus.$emit("notifications_modal", {
						type 	: "warning",
						message : this.$ml.get("no_have_permission_edit") + " : " + (this.$route.name || "face") 
					});
					return false
				}
				let info_up 	= { ...this.info };
				if (info_up && info_up.id) {
					let api 		= this.$URL + "/api/v1/face/trained/" + info_up.id;
					if (this.info && this.info.type == "user") {
						api 		= this.$URL + "/api/v1/face/add/" + info_up.userId; // user 
					}
					this.loading 	= true;
					let formData 	= new FormData();
		        	for(let it in info_up){
		        		// console.log("IT ", it, info_up[it])
				        if (it && info_up[it] && it != "files") {
			        		formData.append(it, info_up[it]);
				        }
		        	}
			         if (info_up.files && info_up.files.length > 0) {
			        	info_up.files.forEach((it, idx)=>{
			        		formData.append("files" + idx , it);
			        	})
		        	}
		        
					this.$axios.put(api, formData).then(res => {
						this.loading = false;
						if (res && res.data) {
							this.show.add 	= false;
							this.list_faces = [];
								// console.log("CHECK ADD LIST update ", this.info)
							if (this.info && this.info.face_trained && this.info.face_trained.length > 0) {
								if (res.data.face_trained && res.data.face_trained.length > 0) {
									this.info.face_trained = this.info.face_trained.concat(res.data.face_trained);

								}								
							}else if (this.info) {
								if (res.data.face_trained && res.data.face_trained.length > 0) {
									this.info.face_trained = res.data.face_trained;
								}
							}

							this.$Format.update_to_lists("list_traineds", {...this.info});
							this.item_info 	= null
							if (this.info && this.info.files) {
								delete this.info.files;
							}
							this.info 	  	= { type : "user"};			

						}
						this.$EventBus.$emit("notifications_modal", {
							type 	: "updated",
						});
					}).catch(er => {
						this.loading = false;
						console.log( "Error update trained ", er)
						this.$EventBus.$emit("notifications_modal", {
							type 	: "error",
							message : er,
						});
					})
		        }else{
		        	this.$EventBus.$emit("notifications_modal", {
		        		type 	: "warning",
		        		message : this.$ml.get("req_id_to_update")
		        	})
		        }
				
			}, // update

			del(item){
				if (item && item.id) {
					this.loading 	= true;
					
					let api 		= this.$URL + "/api/v1/face/trained/" + item.id;
					if (this.info && this.info.type == "user" ) {
						api 		= this.$URL + "/api/v1/face/user/" + item.userId
					}
					// console.log()
					this.$axios.delete(api).then(res => {
						this.loading = false;
						
						let idx = this.list.findIndex(x => (x && x.id == item.id));
						if (idx >= 0) {
							this.list.splice(idx, 1);
						}
						this.$Format.delete_to_lists("list_traineds", { ...item });

						this.item_info = null;			

						this.$EventBus.$emit("notifications_modal", {
							type 	: "deleted",
						});

					this.show.add = false; 
					this.head.action = "save";
					this.head.subtitle = this.$ml.get("new");
					}).catch(er => {
						this.loading = false;
						console.log( "Error delete trained ", er)
						this.$EventBus.$emit("notifications_modal", {
							type 	: "error",
							message : er,
						});
					})
		        }else{
		        	this.$EventBus.$emit("notifications_modal", {
		        		type 	: "warning",
		        		message : this.$ml.get("req_id_del"),
		        	})
		        }
			}, // del

			del_face(item){
				if (item && item.id) {
					this.loading 	= true;
					const api 		= this.$URL + "/api/v1/face/trained/" + item.id;
					this.$axios.delete(api).then(res => {
						this.loading = false;
						if (this.info && this.info.face_trained && this.info.face_trained.length > 0) {

							let idx = this.info.face_trained.findIndex(x => (x && x.id == item.id));
							if (idx >= 0) {
								this.info.face_trained.splice(idx, 1);
							}
						}
						this.item_info = null;			

						this.$EventBus.$emit("notifications_modal", {
							type 	: "deleted",
						});
					}).catch(er => {
						this.loading = false;
						console.log( "Error delete trained ", er)
						this.$EventBus.$emit("notifications_modal", {
							type 	: "error",
							message : er,
						});
					})
		        }else{
		        	if (item && item.key) {
		        		let idx = this.list_faces.findIndex(x => (x &&  x.key === item.key));
		        		if (idx >= 0) {
							this.list_faces.splice(idx, 1);		       
							this.info.files.splice(idx, 1);	        			
		        		}		        		
		        	}else{

			        	this.$EventBus.$emit("notifications_modal", {
			        		type 	: "warning",
			        		message : this.$ml.get("req_id_del"),
			        	})
		        	}
		        }
			}, // del face

			to_train_face(action, item){
				if (item && item.selecteds && item.selecteds.length > 0) {
					let url_  		= "/api/v1/face/";
					let field 		= "userId";
					let type_crud  	= "post";
					if (action == "to_delete") {
						url_ 		= "/api/v1/face/";
						type_crud  	= "delete";
					}
					item.selecteds.forEach(async (face)=>{
						if (face && face[field]) {

							const api = this.$URL + "" + face[field];
							await this.$axios[type_crud](api, face).then(res=>{
								return true;
							}).catch(er => {
								console.log("Error to train face ", er )
								return true;
							})
						}
					});
				}else{
					console.warn("No found list delete")
				}
			}, // to_train_face
			
			// Verificar si existe integración CitizenFaceAPI
			async checkCitizenFaceAPIIntegration() {
				try {
					this.loadingIntegrations = true;
					const api = this.$URL + '/api/v1/cloud/?page=1';
					const response = await this.$axios.get(api);
					
					if (response.data && response.data.rows) {
						const citizenIntegration = response.data.rows.find(
							integration => integration.type_integrate === 'CitizenFaceAPI'
						);
						this.citizenFaceAPIExists = !!citizenIntegration;
						this.citizenIntegration = citizenIntegration || null;
					}
				} catch (error) {
					console.warn('Error checking CitizenFaceAPI integration:', error);
					this.citizenFaceAPIExists = false;
					this.citizenIntegration = null;
				} finally {
					this.loadingIntegrations = false;
				}
			},
			
			// Abrir modal CitizenFaceAPI
			openCitizenModal() {
				this.showCitizenModal = true;
				this.citizenId = '';
				this.citizenResult = null;
			},
			
			// Consultar ciudadano usando CitizenFace API
			async consultarCiudadano() {
				if (!this.citizenId || !this.citizenIntegration) {
					this.$EventBus.$emit("notifications_modal", {
						type: "warning",
						message: "Citizen ID and integration required"
					});
					return;
				}
				
				// Función auxiliar para hacer la consulta
				const hacerConsulta = async (token) => {
					const baseUrl = this.citizenIntegration.ip_address;
					const endpoint = '/asapZurag/checkCitizen';
					const url = `${baseUrl}${endpoint}?regnum=${this.citizenId}`;
					
					const response = await this.$axios.get(url, {
						headers: {
							'Authorization': `Bearer ${token}`,
							'Content-Type': 'application/json'
						}
					});
					
					return { response, url };
				};
				
				// Función auxiliar para procesar respuesta exitosa
				const procesarRespuestaExitosa = (response) => {
					if (response.data && response.data.data && response.data.data.image) {
						const ciudadanoData = response.data.data;
						this.citizenResult = {
							success: true,
							message: 'Consulta exitosa',
							image: ciudadanoData.image,
							firstname: ciudadanoData.firstname || ciudadanoData.firstName || '',
							lastname: ciudadanoData.lastname || ciudadanoData.lastName || '',
							gender: ciudadanoData.gender || '',
							birthDate: ciudadanoData.birthDateAsText || ciudadanoData.birthDate || '',
							civilId: ciudadanoData.civilId || '',
							address: ciudadanoData.addressStreetName || ciudadanoData.address || ''
						};
						
						this.$EventBus.$emit("notifications_modal", {
							type: "success",
							message: 'Consulta exitosa'
						});
						
						return true;
					} else {
						this.citizenResult = {
							success: false,
							message: 'La respuesta no contiene imagen del ciudadano',
							image: null
						};
						
						this.$EventBus.$emit("notifications_modal", {
							type: "warning",
							message: 'La respuesta no contiene imagen del ciudadano'
						});
						
						return false;
					}
				};
				
				try {
					this.loadingCitizenQuery = true;
					this.citizenResult = null;
					
					// Obtener el token actual
					let token = this.citizenIntegration.password;
					
					// Primer intento con el token actual
					try {
						const { response } = await hacerConsulta(token);
						if (procesarRespuestaExitosa(response)) {
							return; // Éxito en el primer intento
						}
					} catch (firstError) {
						console.log('Primer intento falló:', firstError.message);
						
						// Verificar si es un error de token (401, 403, o mensaje específico)
						const isTokenError = firstError.response && (
							firstError.response.status === 401 || 
							firstError.response.status === 403 ||
							firstError.response.data?.message?.toLowerCase().includes('token') ||
							firstError.response.data?.message?.toLowerCase().includes('jwt') ||
							firstError.response.data?.message?.toLowerCase().includes('unauthorized') ||
							firstError.response.data?.message?.toLowerCase().includes('malformed')
						);
						
						if (isTokenError) {
							console.log('Error de token detectado, intentando renovar...');
							
							try {
								// Renovar el token
								await this.refreshToken();
								
								// Obtener el nuevo token
								token = this.citizenIntegration.password;
								
								// Segundo intento con el nuevo token
								console.log('Token renovado, reintentando consulta...');
								const { response: retryResponse } = await hacerConsulta(token);
								
								if (procesarRespuestaExitosa(retryResponse)) {
									return; // Éxito en el reintento
								}
								
							} catch (refreshError) {
								console.error('Error renovando token:', refreshError);
								// Continuar con el manejo de error original
							}
						}
						
					}
					
				} catch (error) {
					console.error('Error general en consulta:', error);
					
					// Procesar error final
					this.citizenResult = {
						success: false,
						message: error.response?.data?.message || error.message || 'Error en la consulta',
						image: null
					};
					
					this.$EventBus.$emit("notifications_modal", {
						type: "error",
						message: 'Error en la consulta'
					});
				} finally {
					this.loadingCitizenQuery = false;
				}
			},
			
			// Agregar ciudadano a la lista de trained
			async addCitizenToTrained() {
				if (!this.citizenResult || !this.citizenResult.image) {
					this.$EventBus.$emit("notifications_modal", {
						type: "warning",
						message: 'Citizen image is required'
					});
					return;
				}
				
				this.loadingAddCitizen = true;
				
				try {
					// Extraer base64 sin data:image prefix para validación
					let base64Image = this.citizenResult.image;
					if (base64Image.startsWith('data:image/')) {
						base64Image = base64Image.split(',')[1];
					}
					
					// Crear objeto face para validación
					const tempImg = { imgBase64: base64Image, isActive: true };
					
					// Validar face usando el mismo helper que import button
					const res = await this.$Helper.validateFaceUpload([tempImg]);
					
					if (res && res.data && res.data.length) {
						const item = res.data[0];
						
						if (item && item.bbox) {
							// Face validation successful - create face object
							const temp = {
								imgBase64: `data:image/jpeg;base64,${base64Image}`, // Add data prefix for display
								url_face: `data:image/jpeg;base64,${base64Image}`, // Para compatibilidad con el template
								key: this.list.length + 1,
								isValid: true,
								uuid: this.$Helper.generateUUIDv4(),
								name: `CITIZEN_${this.citizenId}`,
								citizenId: this.citizenId,
								firstname: this.citizenResult.firstname || 'Unknown',
								lastname: this.citizenResult.lastname || '',
								gender: this.citizenResult.gender || '',
								birthDate: this.citizenResult.birthDate || '',
								civilId: this.citizenResult.civilId || '',
								msg: `CITIZEN_${this.citizenId}` // Para mostrar en la tarjeta
							};
							
							// Limpiar lista de faces y agregar la nueva imagen
							this.list_faces = [];
							this.list_faces.push(temp);
							
							// Llenar el formulario con la información del ciudadano
							this.info = {
								type: "user",
								name: `${this.citizenResult.firstname || 'Unknown'} ${this.citizenResult.lastname || ''}`.trim(),
								userName: this.citizenId,
								email: `${this.citizenId}@citizen.local`
							};
							
							// Mostrar el formulario
							this.show.add = true;
							this.head.action = "save";
							this.head.subtitle = this.$ml.get("new");
							this.actions("show_type");
							
							// Forzar actualización de la vista
							this.$nextTick(() => {
								// Verificar que la imagen se agregó correctamente
								console.log('List faces después de agregar:', this.list_faces);
								console.log('Imagen agregada:', temp);
							});
							
							// Cerrar el modal
							this.showCitizenModal = false;
							
							this.$EventBus.$emit("notifications_modal", {
								type: "success",
								message: 'Citizen face validated and added to trained list successfully'
							});
							
						} else {
							// Face validation failed
							this.$EventBus.$emit("notifications_modal", {
								type: "warning",
								message: item?.msg || 'Face validation failed - no face detected in the image'
							});
						}
					} else {
						this.$EventBus.$emit("notifications_modal", {
							type: "warning",
							message: 'Face validation failed - invalid response'
						});
					}
					
				} catch (error) {
					console.error('Error adding citizen to trained:', error);
					this.$EventBus.$emit("notifications_modal", {
						type: "error",
						message: error.message || 'Error adding citizen to trained list'
					});
				} finally {
					this.loadingAddCitizen = false;
				}
			},
			
			// Refrescar token de CitizenFace API
			async refreshToken() {
				if (!this.citizenIntegration) {
					this.$EventBus.$emit("notifications_modal", {
						type: "warning",
						message: 'Citizen integration not configured'
					});
					return;
				}

				try {
					const baseUrl = this.citizenIntegration.ip_address;
					const endpoint = '/asapZurag/token';
					const url = `${baseUrl}${endpoint}`;

					// Credenciales para autenticación básica
					const username = 'AsapZurag';
					const password = 'c~G/%Yo_mhRUxaYo!tc5pcHu%|wJc~G/%Yo_mhRUxaYo!tc5pcHu%|wJ';
					
					// Crear token base64 para Basic Auth
					const basicAuth = btoa(`${username}:${password}`);

					const response = await this.$axios.get(url, {
						headers: {
							'Authorization': `Basic ${basicAuth}`,
							'Content-Type': 'application/json'
						}
					});

					// Verificar que la respuesta contenga el token
					if (response.data && response.data.token) {
						// Actualizar el token en la integración
						this.citizenIntegration.password = response.data.token;
						
						this.$EventBus.$emit("notifications_modal", {
							type: "success",
							message: 'Token actualizado exitosamente'
						});
						
						console.log('Token actualizado:', response.data.token);
					} else {
						throw new Error('Respuesta no contiene token válido');
					}

				} catch (error) {
					console.error('Error refreshing token:', error);
					this.$EventBus.$emit("notifications_modal", {
						type: "error",
						message: error.response?.data?.message || error.message || 'Error al refrescar el token'
					});
					throw error; // Re-lanzar para que el método principal lo maneje
				}
			},

			// Folder Import methods
			openFolderImportModal() {
				this.showFolderImportModal = true;
				this.folderImportInfo = {
					name: '',
					email: ''
				};
				this.selectedFolder = null;
				this.selectedFiles = [];
				this.compressionProgress = {
					show: false,
					percentage: 0,
					currentFile: '',
					totalFiles: 0
				};
			},

			closeFolderImportModal() {
				this.showFolderImportModal = false;
				this.folderImportInfo = {
					name: '',
					email: ''
				};
				this.selectedFolder = null;
				this.selectedFiles = [];
				this.compressionProgress = {
					show: false,
					percentage: 0,
					currentFile: '',
					totalFiles: 0
				};
			},

			async handleFolderSelection(event) {
				this.loadingFolderSelection = true;
				this.selectedFiles = [];
				const files = event.target.files;
				for (let i = 0; i < files.length; i++) {
					const file = files[i];
					if (file.type.startsWith('image/')) {
						this.selectedFiles.push(file);
					} else {
						this.$EventBus.$emit("notifications_modal", {
							type: "warning",
							message: `${file.name} is not an image file.`
						});
					}
				}
				this.loadingFolderSelection = false;
			},

			getFilePreview(file) {
				if (file.type.startsWith('image/')) {
					return URL.createObjectURL(file);
				}
				return '/img/no_img_found.png'; // Fallback for non-image files
			},

			async processFolderImport() {
				if (!this.canProcessFolder) {
					this.$EventBus.$emit("notifications_modal", {
						type: "warning",
						message: "Please select a folder and files to process."
					});
					return;
				}

				this.loadingFolderImport = true;
				this.compressionProgress.show = true;
				this.compressionProgress.percentage = 0;
				this.compressionProgress.currentFile = '';
				this.compressionProgress.totalFiles = this.selectedFiles.length;

				for (let i = 0; i < this.selectedFiles.length; i++) {
					const file = this.selectedFiles[i];
					this.compressionProgress.currentFile = `${i + 1}/${this.compressionProgress.totalFiles}`;
					await this.compressAndUploadImage(file, i);
				}

				this.loadingFolderImport = false;
				this.closeFolderImportModal();
				this.$EventBus.$emit("notifications_modal", {
					type: "success",
					message: "All images processed and imported successfully!"
				});
			},

			// Método para abrir el modal de importación de carpetas
			openFolderImportModal() {
				this.showFolderImportModal = true;
				this.folderFiles = [];
				this.folderImportErrors = [];
				this.resetProcessingState();
			},
			
			// Método para resetear el estado del procesamiento
			resetProcessingState() {
				this.processingStatus = 'idle';
				this.processingProgress = {
					current: 0,
					total: 0,
					percentage: 0
				};
				this.processingLogs = [];
				this.processingDetails = {
					currentFile: '',
					currentOperation: '',
					estimatedTime: ''
				};
			},
			
			// Método para limpiar los logs
			clearProcessingLogs() {
				this.processingLogs = [];
			},
			
			// Método para obtener la clase CSS de los logs
			getLogEntryClass(logType) {
				const classes = {
					'info': 'text-info',
					'success': 'text-success',
					'warning': 'text-warning',
					'error': 'text-error'
				};
				return classes[logType] || 'text-info';
			},

			// Método para manejar la selección de carpetas
			handleFolderSelection(files) {
				if (files && files.length > 0) {
					this.folderFiles = files;
					this.folderImportErrors = [];
					
					// Validar que todos los archivos sean imágenes
					const invalidFiles = files.filter(file => !file.type.startsWith('image/'));
					if (invalidFiles.length > 0) {
						this.folderImportErrors.push(`${invalidFiles.length} archivos no son imágenes válidas`);
					}
				} else {
					this.folderFiles = [];
					this.folderImportErrors = [];
				}
			},

			// Método para comprimir y enviar la carpeta
			async compressAndUploadFolder() {
				if (!this.folderFiles || this.folderFiles.length === 0) {
					this.$EventBus.$emit("notifications_modal", {
						type: "warning",
						message: "No hay archivos seleccionados para procesar"
					});
					return;
				}

				this.loadingCompression = true;
				this.processingStatus = 'processing';
				this.processingProgress.total = this.folderFiles.length;
				this.processingProgress.current = 0;
				this.processingProgress.percentage = 0;
				
				// Agregar log inicial
				this.addProcessingLog('info', `Iniciando procesamiento de ${this.folderFiles.length} archivos`);
				
				try {
					// Crear un archivo ZIP con todas las imágenes
					this.addProcessingLog('info', 'Creando archivo ZIP...');
					this.processingDetails.currentOperation = 'Creando ZIP';
					
					const JSZip = await import('jszip');
					const zip = new JSZip.default();
					
					// Agregar cada imagen al ZIP
					for (let i = 0; i < this.folderFiles.length; i++) {
						const file = this.folderFiles[i];
						if (file.type.startsWith('image/')) {
							zip.file(file.name, file);
						}
					}
					
					this.addProcessingLog('success', 'Archivo ZIP creado exitosamente');
					
					// Generar el ZIP
					this.processingDetails.currentOperation = 'Generando ZIP';
					this.addProcessingLog('info', 'Generando archivo ZIP...');
					const zipBlob = await zip.generateAsync({ type: 'blob' });
					
					// Crear FormData para enviar al backend
					const formData = new FormData();
					formData.append('folder_zip', zipBlob, 'folder_images.zip');
					formData.append('folder_name', 'imported_folder');
					formData.append('total_files', this.folderFiles.length.toString());
					
					// Configurar EventBus para recibir actualizaciones en tiempo real
					this.setupRealTimeUpdates();
					
					// Enviar al backend
					this.processingDetails.currentOperation = 'Enviando al backend';
					this.addProcessingLog('info', 'Enviando archivo al backend...');
					
					const api = this.$URL + "/api/v1/face/import-folder";
					const response = await this.$axios.post(api, formData, {
						headers: {
							'Content-Type': 'multipart/form-data'
						},
						onUploadProgress: (progressEvent) => {
							const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
							this.processingProgress.percentage = percentCompleted;
							this.addProcessingLog('info', `Progreso de envío: ${percentCompleted}%`);
						}
					});
					
					if (response && response.data) {
						this.addProcessingLog('success', 'Archivo enviado exitosamente al backend');
						this.addProcessingLog('info', 'Esperando confirmación del procesamiento...');
						
						// El backend debería enviar actualizaciones via EventBus
						// Por ahora, simulamos el procesamiento
						this.simulateBackendProcessing();
					}
					
				} catch (error) {
					console.error('Error al importar carpeta:', error);
					this.addProcessingLog('error', `Error al enviar archivo: ${error.message}`);
					this.processingStatus = 'error';
					
					this.$EventBus.$emit("notifications_modal", {
						type: "error",
						message: error.response?.data?.message || error.message || 'Error al importar la carpeta'
					});
				} finally {
					this.loadingCompression = false;
				}
			},
			
			// Método para configurar las actualizaciones en tiempo real
			setupRealTimeUpdates() {
				// Escuchar eventos del backend via EventBus
				this.eventBusListener = (data) => {
					if (data.type === 'folder_processing_update') {
						this.handleProcessingUpdate(data);
					}
				};
				
				this.$EventBus.$on('folder_processing_update', this.eventBusListener);
				
				// También configurar WebSocket si está disponible
				this.setupWebSocketConnection();
			},
			
			// Método para manejar actualizaciones del procesamiento
			handleProcessingUpdate(data) {
				switch (data.status) {
					case 'progress':
						this.processingProgress.current = data.current || 0;
						this.processingProgress.percentage = data.percentage || 0;
						this.processingDetails.currentFile = data.currentFile || '';
						this.processingDetails.currentOperation = data.operation || '';
						this.processingDetails.estimatedTime = data.estimatedTime || '';
						
						if (data.log) {
							this.addProcessingLog(data.logType || 'info', data.log);
						}
						break;
						
					case 'completed':
						this.processingStatus = 'completed';
						this.processingProgress.current = this.processingProgress.total;
						this.processingProgress.percentage = 100;
						this.addProcessingLog('success', 'Procesamiento completado exitosamente');
						
						// Limpiar archivos seleccionados
						this.folderFiles = [];
						
						// Recargar la lista de trained
						this.get_list_trained();
						
						// Mostrar notificación
						this.$EventBus.$emit("notifications_modal", {
							type: "success",
							message: `Carpeta procesada exitosamente. ${this.processingProgress.total} archivos procesados.`
						});
						break;
						
					case 'error':
						this.processingStatus = 'error';
						this.addProcessingLog('error', data.error || 'Error en el procesamiento');
						break;
				}
			},
			
			// Método para agregar logs al procesamiento
			addProcessingLog(type, message) {
				const timestamp = new Date().toLocaleTimeString();
				this.processingLogs.push({
					type,
					message,
					timestamp
				});
				
				// Mantener solo los últimos 100 logs
				if (this.processingLogs.length > 100) {
					this.processingLogs.shift();
				}
				
				// Auto-scroll al final
				this.$nextTick(() => {
					const container = document.querySelector('.processing-logs-container');
					if (container) {
						container.scrollTop = container.scrollHeight;
					}
				});
			},
			
			// Método para configurar conexión WebSocket (opcional)
			setupWebSocketConnection() {
				try {
					// Si tienes WebSocket configurado, puedes usarlo aquí
					// const ws = new WebSocket('ws://localhost:3000/folder-processing');
					// this.websocketConnection = ws;
					
					// ws.onmessage = (event) => {
					//     const data = JSON.parse(event.data);
					//     this.handleProcessingUpdate(data);
					// };
					
					// ws.onerror = (error) => {
					//     this.addProcessingLog('error', 'Error en conexión WebSocket');
					// };
				} catch (error) {
					console.log('WebSocket no disponible, usando solo EventBus');
				}
			},
			
			// Método para simular el procesamiento del backend (temporal)
			simulateBackendProcessing() {
				let currentFile = 0;
				const totalFiles = this.folderFiles.length;
				
				const interval = setInterval(() => {
					if (currentFile < totalFiles) {
						const fileName = this.folderFiles[currentFile].name;
						this.processingDetails.currentFile = fileName;
						this.processingDetails.currentOperation = 'Procesando imagen';
						
						this.addProcessingLog('info', `Procesando: ${fileName}`);
						
						currentFile++;
						this.processingProgress.current = currentFile;
						this.processingProgress.percentage = Math.round((currentFile / totalFiles) * 100);
						
						// Simular tiempo de procesamiento
						this.processingDetails.estimatedTime = `${Math.round((totalFiles - currentFile) * 0.5)}s`;
					} else {
						clearInterval(interval);
						this.handleProcessingUpdate({
							status: 'completed',
							current: totalFiles,
							percentage: 100
						});
					}
				}, 500); // Simular 500ms por archivo
			}

		}, //methods

		mounted(){
			// this.$Format.update_list('ml',this.$ml)
			let temp = "notifications_modal" + this.ID_notification;
			this.$EventBus.$on(temp, this.bus[temp] = (confirm, actions)=>{
				if (confirm && actions) {
					if (actions.action == 'del') {
						this.del(this.item_info);
					}else if (actions.action == "del_face"){
						this.del_face(this.item_info);
					}
				}
			});
			
			// Verificar si existe integración CitizenFaceAPI al montar el componente
			this.checkCitizenFaceAPIIntegration();
		},// mounted

		beforeDestroy(){
			this.$Helper.clear_bus(this.$EventBus, this.bus, this.ID_notification);
			
			// Limpiar listener del EventBus para procesamiento de carpetas
			if (this.eventBusListener) {
				this.$EventBus.$off('folder_processing_update', this.eventBusListener);
			}
			
			// Cerrar conexión WebSocket si existe
			if (this.websocketConnection) {
				this.websocketConnection.close();
			}
		}, // beforeDestroy

	}; 
</script>